import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import TopBar from './TopBar';
import { Outlet } from 'react-router-dom';

const TOPBAR_HEIGHT = 64;

function HomePageLayout({ children }) {
  return (
    <Box
      sx={{
        backgroundColor: (theme) => theme.palette.background.default,
        display: 'flex',
        height: '100%',
        overflow: 'hidden',
        width: '100%'
      }}
    >
      <TopBar />
      <Box
        sx={{
          display: 'flex',
          flex: '1 1 auto',
          overflow: 'hidden',
          pt: `${TOPBAR_HEIGHT}px`
        }}
      >
        <Box
          sx={{
            flex: '1 1 auto',
            height: '100%',
            overflow: 'auto'
          }}
        >
          {children || <Outlet />}
        </Box>
      </Box>
    </Box>
  );
}

HomePageLayout.propTypes = {
  children: PropTypes.node
};

export default HomePageLayout;
